export default "__VITE_ASSET__DnenSUA4__"